/**
 * Pure URL utility functions for CdpPayCalendar
 * Handles URL construction for routing
 */

import moment from 'moment';

/**
 * Build calendar URL with month, year, and doctor abbreviation
 * @param {string} basePath - Base path from match.url (e.g., '/payandreports/cdp-pay')
 * @param {string|Date} date - Date for month/year
 * @param {string} abbr - Doctor abbreviation
 * @returns {string} Complete URL path
 */
export const buildCalendarUrl = (basePath, date, abbr = '') => {
  const month = moment(date).format('MM');
  const year = moment(date).format('YYYY');
  const urlParts = basePath.split('/');
  const baseRoute = urlParts.slice(0, 3).join('/'); // Get /payandreports/cdp-pay
  
  return `${baseRoute}/${month}/${year}/${abbr}`;
};

/**
 * Parse calendar parameters from route match object
 * @param {Object} match - React Router match object
 * @returns {Object} { month, year, abbr, basePath }
 */
export const parseCalendarParams = (match) => {
  return {
    month: match?.params?.month || null,
    year: match?.params?.year || null,
    abbr: match?.params?.abbr || null,
    basePath: match?.url || ''
  };
};

/**
 * Extract base route from URL (first 3 segments)
 * @param {string} url - Full URL path
 * @returns {string} Base route
 */
export const getBaseRoute = (url) => {
  const urlParts = url.split('/');
  return urlParts.slice(0, 3).join('/');
};
